export default {
    RESPONSE_CODE_LIST: {
        SUCCESS: 200,
        TOKEN_INVALID: 401
    },
    //1.乡 2.镇 3.街道 4 社区
    townTypeStr: {
        1: '乡',
        2: '镇',
        3: '街道',
        4: '社区'
    },
    checkResultStr: {
        1: '不存在',
        2: '存在'
    },
    // 1上线、0下线
    lineStatusStr: {
        0: '下线',
        1: '上线'
    },

    lineStatusFanStr: {
        1: '下线',
        0: '上线'
    },

    // 1采集中、2修正中、3修正完成
    collectStatusStr: {
        1: '采集中',
        2: '修正中',
        3: '修正完成'
    },



    // 申请理由 1. 旱厕改造  2. 无厕新建  3. 卫生厕所提升改造
    applyReasonStr: {
        1: '旱厕改造',
        2: '无厕新建',
        3: '卫生厕所提升改造'
    },

    // 三格式材料：1. 复合材料一体式  2. 砖混结构
    threeCellMaterialStr: {
        1: '复合材料一体式',
        2: '砖混结构'
    },

    // 1. 三格式化粪池  2. 卫生旱厕  3. 化粪池纳入污水管网
    rebuildContentStr: {
        1: '三格式化粪池',
        2: '卫生旱厕',
        3: '化粪池纳入污水管网',
        4: '沼气池'
    },

    // 改造部位：1. 厕屋改造2. 化粪池改造
    reformPartStr: {
        1: '厕屋改造',
        2: '化粪池改造'
    },
    //活动阶段 1.未开始 2.报名中 3.待开营 4.已开营 5.已结营 6.投票中 7.已结束
    stageStr: {
        1: '未开始',
        2: '报名中',
        3: '待开营',
        4: '已开营',
        5: '已结营',
        6: '投票中',
        7: '已结束'
    },

    USERFORMKEYS: [
        {
            value: 'name',
            label: '姓名（文本输入）'
        },
        {
            value: 'phone',
            label: '手机号（文本输入）'
        },
        {
            value: 'idCard',
            label: '身份证号（文本输入）'
        },
        {
            value: 'school',
            label: '学校（文本输入）'
        },
        {
            value: 'major',
            label: '专业（文本输入）'
        },
        {
            value: 'grade',
            label: '年级(下拉单选)'
        },
        {
            value: 'email',
            label: '邮箱（文本输入）'
        },
        {
            value: 'county',
            label: '家乡（下拉单选）'
        },
        {
            value: 'homeAddress',
            label: '家庭地址（文本输入）'
        },
        {
            value: 'haveLaptop',
            label: '是否有电脑（单选）'
        },
        {
            value: 'havePhotographic',
            label: '是否有摄影器材（单选）'
        },
        {
            value: 'isJoinedActivities',
            label: '是否参加过活动（单选）'
        },
        {
            value: 'isStudiedPhotography',
            label: '是否学过摄影（单选）'
        },
        {
            value: 'isStudiedPanoramicProduction',
            label: '是否学过全景制作（单选）'
        }

    ],

    // 采集状态：1采集中、2修正中、3修正完成
    COLLECT_STATUS: [
        {
            value: 1,
            label: '采集中'
        },
        {
            value: 2,
            label: '修正中'
        },
        {
            value: 3,
            label: '修正完成'
        }
    ],



    VILLAGE_ONLINE_STATUS: [
        {
            value: 0,
            label: '下线'
        },
        {
            value: 1,
            label: '上线'
        }
    ],
    ACTIVE_STAGE: [
        {
            value: 1,
            label: '未开始'
        },
        {
            value: 2,
            label: '报名中'
        },
        {
            value: 3,
            label: '待开营'
        },
        {
            value: 4,
            label: '已开营'
        },
        {
            value: 5,
            label: '已结营'
        },
        {
            value: 6,
            label: '投票中'
        }
        ,
        {
            value: 7,
            label: '已结束'
        }
    ],
    MONITOR_BINDS_PORT: [
        {
            value: 2,
            label: '出水口'
        },
        {
            value: 1,
            label: '进水口'
        }
    ],
    MONIROR_BINDS: [
        {
            value: 0,
            label: '未绑定'
        },
        {
            value: 1,
            label: '已绑定'
        }
    ],
    MONITOR_ERROR: [
        {
            value: 0,
            label: '否'
        },
        {
            value: 1,
            label: '是'
        }
    ],
    TRAN_HAS_STATION: [
        {
            value: 1,
            label: '自有站点'
        },
        {
            value: 2,
            label: '自有临时站点'
        },
        {
            value: 3,
            label: '无站点'
        }
    ],
    SEND_TYPE: [
        {
            value: 1,
            label: '手机短信'
        },
        {
            value: 2,
            label: '数字乡村APP'
        }
    ],
    MESSAGE_TYPE: [
        {
            value: 1,
            label: '预警'

        },
        {
            value: 2,
            label: '通知'
        },
        {
            value: 3,
            label: '公告'
        }
    ],
    SERVICE_TYPE: [
        {
            value: 1,
            label: '基础服务'
        },
        {
            value: 2,
            label: '增值服务'
        }
    ],
    TRAN_CONSTRUCTION_STATUS: [
        {
            value: 1,
            label: '建成'
        },
        {
            value: 2,
            label: '在建'
        },
    ],
    MONITOR_STATUS: [
        {
            value: 1,
            label: '使用中'
        },
        {
            value: 2,
            label: '维修中'
        },
        {
            value: 3,
            label: '废弃'
        }
    ],
    TRAN_STATUS: [
        {
            value: '1',
            label: '运行中'
        },
        {
            value: '2',
            label: '维修中'
        },
    ],
    DISPOSAL_METHOD: [
        {
            value: 1,
            label: '自有转运'
        },
        {
            value: 2,
            label: '共建共享'
        },
        {
            value: 3,
            label: '直收直运'
        },
        {
            value: 4,
            label: '被城区覆盖'
        },
        {
            value: 5,
            label: '小型无害化焚烧处理'
        },
    ],
    // 上个月字典
    lastMonthDic: {
        '01': '12',
        '02': '1',
        '03': '2',
        '04': '3',
        '05': '4',
        '06': '5',
        '07': '6',
        '08': '7',
        '09': '8',
        '10': '9',
        '11': '10',
        '12': '11'
    },
    resetAppleStatusStr: {
        1: '待审核',
        2: '改造中',
        3: '改造完成',
        4: '不通过',
    },
    RESET_APPLE_STATUS: [
        {
            value: 2,
            label: '待审核'
        },
        {
            value: 3,
            label: '改造中'
        },
        {
            value: 4,
            label: '改造完成'
        },
        {
            value: 5,
            label: '不通过'
        }
    ],
    // 申请状态 1待申请、2待审核、3改造中、4改造完成、5不通过
    appleStatusStr: {
        1: '待申请',
        2: '待审核',
        3: '改造中',
        4: '改造完成',
        5: '不通过'
    },

    APPLE_STATUS_PLAN: [
        {
            value: 2,
            label: '待审核'
        },
        {
            value: 3,
            label: '改造中'
        },
        {
            value: 4,
            label: '改造完成'
        },
        {
            value: 5,
            label: '不通过'
        }
    ],
    APPLE_STATUS: [
        {
            value: 1,
            label: '待申请'
        },
        {
            value: 2,
            label: '待审核'
        },
        {
            value: 3,
            label: '改造中'
        },
        {
            value: 4,
            label: '改造完成'
        },
        {
            value: 5,
            label: '不通过'
        }
    ],
    // module
    MODULE_TYPE: [
        {
            value: 1,
            label: '垃圾清运'
        },
        {
            value: 2,
            label: '污水处理'
        },
        {
            value: 3,
            label: '住房管理'
        },
        {
            value: 4,
            label: '人居环境'
        },
        {
            value: 5,
            label: '其他'
        },
    ],
    COLLECTION_TYPE: [
        {
            value: 1,
            label: '收集点'
        },
        {
            value: 2,
            label: '非正规收集点'
        },
        {
            value: 3,
            label: '移动收集点'
        },
    ],
    PLATE_ID: [
        {
            value: 1,
            label: '住房直报'
        },
        {
            value: 2,
            label: '住房管理'
        },
        {
            value: 3,
            label: '垃圾清运'
        },
        {
            value: 4,
            label: '污水处理'
        },
        {
            value: 5,
            label: '励志超市'
        },
        {
            value: 6,
            label: '传统村落'
        },
        {
            value: 7,
            label: '城镇建设'
        },
        {
            value: 8,
            label: '人居环境'
        },
        {
            value: 9,
            label: '其他'
        }
    ],
    CURRYEARS: [
        {
            value: '2021',
            label: '2021年'
        },
        {
            value: '2022',
            label: '2022年'
        },
        {
            value: '2023',
            label: '2023年'
        }
    ],
    // 1：脱贫不稳定户；2：边缘易致贫户 3：农村低保户 4：农村分散供养特困人员 5：农村低保边缘家庭 6：农村残疾人家庭 7：严重困难家庭 8：符合条件的其他脱贫户 9：农村一般户
    fmilyTypeStr: {
        1: '脱贫不稳定户',
        2: '边缘易致贫户',
        3: '农村低保户',
        4: '农村分散供养特困人员',
        5: '农村低保边缘家庭',
        6: '农村残疾人家庭',
        7: '突发严重困难家庭',
        8: '符合条件的其他脱贫户',
        9: '农村一般户'
    },
    basinStr: {
        1: '乌江流域',
        2: '赤水流域',
        3: '乌江、赤水流域',
        4: '珠江流域',
        5: '其他',
    },
    // 1.待审核 2.审核通过 3.审核不通过
    auditStatusStr: {
        1: '待审核',
        2: '审核通过',
        3: '审核不通过',
    },
    // 1.场平施工阶段；2.主体建设阶段；3.设备安装阶段；4.竣工验收阶段
    constructionStageStr: {
        1: '场平施工阶段',
        2: '主体建设阶段',
        3: '设备安装阶段',
        4: '竣工验收阶段',
    },
    reportStatusStr: {
        2: '已上报',
        1: '未上报'
    },
    siteConstructionStatusStr: {
        1: '有站点',
        2: '被城区覆盖',
        3: '整乡（镇）搬迁',
        4: '共有污水站点',
    },
    designEmissionStandardStr: {
        1: '一级A标准',
        2: '一级B标准',
        3: '三级标准',
        4: '其他',
        5: '二级标准',
    },
    havaNoStr: {
        1: '有',
        2: '无',
    },
    isNoStr: {
        1: '是',
        2: '否',
    },
    isFinshStr: {
        1: '已完成',
        2: '未完成'
    },
    facilityInvestmentOperationModeStr: {
        1: '建设-运行-移交（BOT)',
        2: '委托运营（O&M）',
        3: '转让-运营-移交（TOT）',
        4: '改建-运营-移交（ROT)',
        5: '政府自建运营',

    },
    implementationEmissionStandardStr: {
        1: '一级A标准',
        2: '一级B标准',
        3: '三级标准',
        4: '其他',
        5: '二级标准',
    },
    constructionStatusStr: {
        1: '已建',
        2: '在建',
        3: '未建',
    },
    GUARANTEEMETHOD_STR: {
        1: '农村危房改造',
        2: '地质灾害避险',
        3: '养老服务机构居住',
        4: '残疾人托养机构',
        5: '整体搬迁',
        6: '其他'
    },
    GUARANTEEMETHOD: [
        // {
        //     value : 1,
        //     label : '农村危房改造'
        // },
        {
            value: 2,
            label: '地质灾害避险'
        },
        {
            value: 3,
            label: '养老服务机构居住'
        },
        {
            value: 4,
            label: '残疾人托养机构'
        },
        {
            value: 5,
            label: '整体搬迁'
        },
        {
            value: 6,
            label: '其他'
        }
    ],
    TOWNTYPE: [
        {
            value: 1,
            label: '乡'
        },
        {
            value: 2,
            label: '镇'
        },
        {
            value: 3,
            label: '街道'
        },
        {
            value: 4,
            label: '社区'
        }
    ],
    rebuildModeStr: {
        1: '异地新建',
        2: '原址重建',
        3: '维修加固',
        4: '房屋置换',
        5: '其他',
        6: '无房新建',
        7: '抗震加固',

    },
    // 审批中、通过、退回
    spStautsStr: {
        1: '不通过',
        2: '退回',
        3: '通过',
        4: '审批中'
    },
    // 自建、委托工匠代建、政府统建
    buildModeStr: {
        1: '自建',
        2: '委托工匠代建',
        3: '政府统建',
    },
    REBUILDMODE: [
        {
            value: 1,
            label: '异地新建'
        },
        {
            value: 2,
            label: '原址重建'
        },
        {
            value: 3,
            label: '维修加固'
        },
        {
            value: 4,
            label: '房屋置换'
        },
        {
            value: 5,
            label: '其他'
        },
        {
            value: 6,
            label: '无房新建'
        },
        {
            value: 7,
            label: '抗震加固'
        }
    ],
    FINISHED_CONDITION: [
        {
            value: 1,
            label: '已完成'
        },
        {
            value: 2,
            label: '未完成'
        },
    ],
    REPORT_STATUS: [
        {
            value: 1,
            label: '未上报'
        },
        {
            value: 2,
            label: '已上报'
        },
    ],
    CONSTRUCTIONSTATUS: [
        {
            value: 1,
            label: '已建'
        },
        {
            value: 2,
            label: '在建'
        },
        {
            value: 3,
            label: '未建'
        },
    ],
    CONSTRUCTION_STATUS: [
        {
            value: 1,
            label: '未上报'
        },
        {
            value: 2,
            label: '已上报'
        },
        {
            value: 3,
            label: '已上报'
        },
    ],
    MONITORS: [
        {
            value: 2,
            label: '监测'
        },
        {
            value: 1,
            label: '不监测'
        },
    ],
    OPERATION_STATUS: [
        {
            value: 1,
            label: '正常运营'
        },
        {
            value: 2,
            label: '暂停运营'
        },
    ],
    AUDITSTATUSDATA: [
        {
            value: 2,
            label: '通过'
        },
        {
            value: 3,
            label: '不通过'
        },
    ],
    TOWN_TYPE: [
        {
            value: 1,
            label: '乡'
        },
        {
            value: 2,
            label: '镇'
        },
        {
            value: 3,
            label: '街道'
        },
        {
            value: 4,
            label: '社区'
        },
    ],
    SITE_CONSTRUCTION_STATUS: [
        {
            value: 1,
            label: '有站点'
        },
        {
            value: 2,
            label: '被城区覆盖'
        },
        {
            value: 3,
            label: '整乡（镇）搬迁'
        },
        {
            value: 4,
            label: '共有污水站点'
        },
    ],
    AUDITSTATUS: [
        {
            value: 1,
            label: '待审核'
        },
        {
            value: 2,
            label: '审核通过'
        },
        {
            value: 3,
            label: '审核不通过'
        },
    ],
    ISFILLED: [
        {
            value: 1,
            label: '是'
        },
        {
            value: 2,
            label: '否'
        },
    ],
    HOUSEHOLDS: [
        {
            value: 1,
            label: '30户以下'
        },
        {
            value: 2,
            label: '30户以上'
        },
    ],
    BUILD_STAGE: [
        {
            "value": 1,
            "label": "场平施工阶段"
        },
        {
            "value": 2,
            "label": "主体施工阶段"
        },
        {
            "value": 3,
            "label": "设备安装阶段"
        },
        {
            "value": 4,
            "label": "竣工验收阶段"
        },
    ],
    DESIGNED_STANDARD: [
        {
            "value": 1,
            "label": "一级A标准"
        },
        {
            "value": 2,
            "label": "一级B标准"
        },
        {
            "value": 5,
            "label": "二级标准"
        },
        {
            "value": 3,
            "label": "三级标准"
        },
        {
            "value": 4,
            "label": "其他"
        },
    ],
    RUN_MODE_FACILITIES: [
        {
            "value": 1,
            "label": "建设-运行-移交(BOT)"
        },
        {
            "value": 2,
            "label": "委托运行(O&M)"
        },
        {
            "value": 3,
            "label": "转让-运营-移交(TOT)"
        },
        {
            "value": 4,
            "label": "改建-运营-移交(ROT)"
        },
        {
            "value": 5,
            "label": "政府自建运营"
        },
    ],
    BASIN: [
        {
            value: 1,
            label: '乌江流域'
        },
        {
            value: 2,
            label: '赤水流域'
        },
        {
            value: 3,
            label: '乌江、赤水流域'
        },
        {
            value: 4,
            label: '珠江流域'
        },
        {
            value: 5,
            label: '其他'
        }
    ],
    BUILDING_PRIGRESS: [
        {
            value: 1,
            label: '有站点'
        },
        {
            value: 2,
            label: '被城区覆盖'
        },
        {
            value: 3,
            label: '整乡（镇）搬迁'
        },
        {
            value: 4,
            label: '共有污水站点'
        }
    ],
    HAVA_NO: [
        {
            value: 1,
            label: '有'
        },
        {
            value: 2,
            label: '无'
        },
    ],
    IS_NO: [
        {
            value: 1,
            label: '是'
        },
        {
            value: 2,
            label: '否'
        },
    ],
    EMISSION_STANDARDS: [
        {
            value: '一级A',
            label: '一级A'
        },
        {
            value: '一级B',
            label: '一级B'
        },
        {
            value: '二级',
            label: '二级'
        },
        {
            value: '三级',
            label: '三级'
        },

    ],
    DIRTY_ACTIVE_TYPE: [
        {
            value: 1,
            label: '改造中'
        },
        {
            value: 2,
            label: '待审核'
        },
        {
            value: 3,
            label: '已退回'
        },
    ],
    DIRECT_FAMILY_TYPE: [
        {
            value: 1,
            label: '脱贫不稳定户'
        },
        {
            value: 2,
            label: '边缘易致贫户'
        },
        {
            value: 3,
            label: '农村低保户'
        },
        {
            value: 4,
            label: '农村分散供养特困人员'
        },
        {
            value: 5,
            label: '农村低保边缘家庭'
        },
        {
            value: 6,
            label: '农村残疾人家庭'
        },
        {
            value: 7,
            label: '突发严重困难家庭'
        },
        {
            value: 8,
            label: '符合条件的其他脱贫户'
        },
        {
            value: 9,
            label: '农村一般户'
        }
    ],
    TOILET_TYPE: [
        {
            "label": "旱厕"
        },
        {
            "label": "卫生厕所"
        },
        {
            "label": "无户厕"
        },
        {
            "label": "到访无人"
        },
    ],
    PUBLIC_TOILET_TYPE: [
        {
            "label": "旱厕"
        },
        {
            "label": "卫生厕所"
        },
    ],
    IS_LOCK: [
        {
            "label": "已锁定"
        },
        {
            "label": "未锁定"
        },
    ],
    TOILET_MODE: [
        {
            "label": "水冲式卫生厕所"
        },
        {
            "label": "卫生旱厕"
        },
        {
            "label": "无意愿"
        },
    ],
    MODIFY_TOILET: [
        {
            "label": "和邻居公用"
        },
        {
            "label": "使用公厕"
        },
        {
            "label": "其他方式"
        },
    ],
    TOILET_NUM: [
        {
            "label": "1个"
        },
        {
            "label": "2个"
        },
        {
            "label": "3个"
        },
        {
            "label": "4个及以上"
        }
    ],
    HOUSE_RECTIFICATION: [
        {
            "label": "已改"
        },
        {
            "label": "未改"
        }
    ],
    ANIMAL_DEAL_WAY: [
        {
            "label": "第三方回收"
        },
        {
            "label": "乱堆乱排"
        },
        {
            "label": "堆肥"
        }
    ],
    ANIMAL_TYPE: [
        {
            "label": "牛"
        },
        {
            "label": "羊"
        },
        {
            "label": "鸡"
        },
        {
            "label": "鸭"
        },
        {
            "label": "猪"
        },
        {
            "label": "鹅"
        },
        {
            "label": "其他"
        }
    ],
    DIRTYWATER_CONDITION: [
        {
            value: '灰水与黑粪水不混流', label: '灰水与黑粪水不混流'
        },
        {
            value: '灰水与黑粪水完全混流', label: '灰水与黑粪水完全混流'
        },
        {
            value: '有厨房用水混入黑粪水', label: '有厨房用水混入黑粪水'
        },
        {
            value: '有洗衣水混入黑粪水', label: '有洗衣水混入黑粪水'
        },
        {
            value: '有洗澡水混入黑粪水', label: '有洗澡水混入黑粪水'
        }

    ],
    HAS_ANIMAL: [
        {
            value: '有养殖', label: '有养殖'
        },
        {
            value: '未养殖', label: '未养殖'
        },
    ],
    TOILET_POSITION: [
        {
            value: '室内', label: '室内'
        },
        {
            value: '室外', label: '室外'
        },
    ],
    TOTLET_TYPE: [
        {
            value: '旱厕', label: '旱厕'
        },
        {
            value: '卫生厕所', label: '卫生厕所'
        }
    ],
    LIVE_CONDITION: [
        {
            value: '常住', label: '常住'
        },
        {
            value: '1年以上不常住', label: '1年以上不常住'
        },
        {
            value: '空挂户', label: '空挂户'
        }
    ],

    PERSON_NUM: [
        {
            value: '1人', label: '1人'
        },
        {
            value: '2人', label: '2人'
        },
        {
            value: '3人', label: '3人'
        },
        {
            value: '4人', label: '4人'
        },
        {
            value: '5人', label: '5人'
        },
        {
            value: '6人及以上', label: '6人及以上'
        },
    ],
    PRIVATE_TOILETS: [
        {
            value: '有户厕', label: '有户厕'
        },
        {
            value: '无户厕', label: '无户厕'
        },
        {
            value: '到访无人', label: '到访无人'
        },
    ],
    PRIVATE_DIRTY_TYPE: [
        {
            value: '简易化粪池', label: '简易化粪池'
        },
        {
            value: '三格式', label: '三格式'
        },
        {
            value: '沼气池式', label: '沼气池式'
        },
        {
            value: '下水道水冲式', label: '下水道水冲式'
        },
        {
            value: '粪尿分集式', label: '粪尿分集式'
        },
        {
            value: '双坑（双池）交替式', label: '双坑（双池）交替式'
        },
        {
            value: '其他类型', label: '其他类型'
        },
    ],
    DIRTY_TYPE: [
        {
            value: '下水道水冲式', label: '下水道水冲式'
        },
        {
            value: '三格式', label: '三格式'
        },
        {
            value: '其他类型', label: '其他类型'
        },
    ],
    PRIVATE_IS_TOILETS: [
        {
            value: '有户厕', label: '有户厕'
        },
        {
            value: '无户厕', label: '无户厕'
        },
        {
            value: '到访无人', label: '到访无人'
        },
    ],
    IS_TOILETS: [
        {
            value: '有公厕', label: '有公厕'
        },
        {
            value: '无公厕', label: '无公厕'
        },
        {
            value: '有公厕但完全无法采集', label: '有公厕但完全无法采集'
        },
    ],
    PLAN_YEAR: [
        {
            value: '2023', label: '2023年'
        },
        {
            value: '2022', label: '2022年'
        },
    ],
    BUILD_YEAR: [
        // {
        //     value: '2024年', label: '2024年'
        // },
        // {
        //     value: '2023年', label: '2023年'
        // },
        // {
        //     value: '2022年', label: '2022年'
        // },
        // {
        //     value: '2021年', label: '2021年'
        // },
        // {
        //     value: '2020年', label: '2020年'
        // },
        // {
        //     value: '2019年', label: '2019年'
        // },
        // {
        //     value: '2018年', label: '2018年'
        // },
        // {
        //     value: '2017年', label: '2017年'
        // },
        // {
        //     value: '2016年', label: '2016年'
        // },
        // {
        //     value: '2015年', label: '2015年'
        // },
        // {
        //     value: '2014年', label: '2014年'
        // },
        // {
        //     value: '2013年', label: '2013年'
        // },
        // {
        //     value: '2012年', label: '2012年'
        // },
        // {
        //     value: '2011年', label: '2011年'
        // },
        // {
        //     value: '2010年', label: '2010年'
        // },
        // {
        //     value: '2009年', label: '2009年'
        // },
        // {
        //     value: '2008年', label: '2008年'
        // },
        // {
        //     value: '2007年', label: '2007年'
        // },
        // {
        //     value: '2006年', label: '2006年'
        // },
        // {
        //     value: '2005年', label: '2005年'
        // },
        // {
        //     value: '2004年', label: '2004年'
        // },
        // {
        //     value: '2003年', label: '2003年'
        // },
        // {
        //     value: '2002年', label: '2002年'
        // },
        // {
        //     value: '2001年', label: '2001年'
        // },
        // {
        //     value: '2000年', label: '2000年'
        // },

        {
            "label": "2024"
        },
        {
            "label": "2023"
        },
        {
            "label": "2022"
        },
        {
            "label": "2021"
        },
        {
            "label": "2020"
        },
        {
            "label": "2019"
        },
        {
            "label": "2018"
        },
        {
            "label": "2017"
        },
        {
            "label": "2016"
        },
        {
            "label": "2015"
        },
        {
            "label": "2014"
        },
        {
            "label": "2013"
        },
        {
            "label": "2012"
        },
        {
            "label": "2011"
        },
        {
            "label": "2010"
        },
        {
            "label": "2009"
        },
        {
            "label": "2008"
        },
        {
            "label": "2007"
        },
        {
            "label": "2006"
        },
        {
            "label": "2005"
        },
        {
            "label": "2004"
        },
        {
            "label": "2003"
        },
        {
            "label": "2002"
        },
        {
            "label": "2001"
        },
        {
            "label": "2000"
        },
        {
            "label": "1999"
        },
        {
            "label": "1998"
        },
        {
            "label": "1997"
        },
        {
            "label": "1996"
        },
        {
            "label": "1995"
        },
        {
            "label": "1994"
        },
        {
            "label": "1993"
        },
        {
            "label": "1992"
        },
        {
            "label": "1991"
        },
        {
            "label": "1990"
        },
        {
            "label": "1989"
        },
        {
            "label": "1988"
        },
        {
            "label": "1987"
        },
        {
            "label": "1986"
        },
        {
            "label": "1985"
        },
        {
            "label": "1984"
        },
        {
            "label": "1983"
        },
        {
            "label": "1982"
        },
        {
            "label": "1981"
        },
        {
            "label": "1980"
        }















    ],
    BUILD_TITLE: [
        {
            value: '2021年', label: '2021年'
        },
        {
            value: '2020年', label: '2020年'
        },
        {
            value: '2019年', label: '2019年'
        },
        {
            value: '2018年', label: '2018年'
        },
        {
            value: '2018年前', label: '2018年前'
        }
    ],
    TOILET_BUILD_WAY: [
        {
            value: '新建', label: '新建'
        },
        {
            value: '改造', label: '改造'
        },
    ],
    MONEY_SOURCE: [
        {
            value: '财政补贴', label: '财政补贴'
        },
        {
            value: '非财政补贴', label: '非财政补贴'
        },
        {
            value: '财政补贴和非财政补贴', label: '财政补贴和非财政补贴'
        },

    ],
    GOVERNMENT_SUBSIDIES: [
        {
            value: '农村厕所革命', label: '农村厕所革命'
        },
        {
            value: '其他财政补助', label: '其他财政补助'
        },
    ],
    PRIVATE_GOVERNMENT_SUBSIDIES: [
        {
            value: '农村厕所革命', label: '农村厕所革命'
        },
        {
            value: '生态污水治理', label: '生态污水治理'
        },
        {
            value: '易地扶贫搬迁', label: '易地扶贫搬迁'
        },
        {
            value: '水库移民', label: '水库移民'
        },
        {
            value: '农危房改造', label: '农危房改造'
        },
        {
            value: '其他财政补助', label: '其他财政补助'
        },
    ],
    AB_GOVERNMENT_SUBSIDIES: [
        {
            value: '乡（镇）自筹', label: '乡（镇）自筹'
        },
        {
            value: '村自筹', label: '村自筹'
        },
        {
            value: '其他非财政补贴', label: '其他非财政补贴'
        },
    ],
    PRIVATE_AB_GOVERNMENT_SUBSIDIES: [
        {
            value: '农户自筹', label: '农户自筹'
        },
        {
            value: '其他非财政补贴', label: '其他非财政补贴'
        }
    ],
    PUBLIC_TITLE: [
        {
            value: '有', label: '有'
        },
        {
            value: '无', label: '无'
        },
    ],
    DIRTY_DEAL_WAY: [
        {
            value: '自行清掏', label: '自行清掏'
        },
        {
            value: '第三方清掏', label: '第三方清掏'
        },
        {
            value: '纳入污水管网', label: '纳入污水管网'
        },
        {
            value: '漏排', label: '漏排'
        },
    ],
    THREE_BUILD_TYPES: [
        {
            value: '砖混结构', label: '砖混结构'
        },
        {
            value: '复合材料一体式', label: '复合材料一体式'
        },
    ],
    IS_USES: [
        {
            value: '是', label: '是'
        },
        {
            value: '否', label: '否'
        },
    ],
    ABNORMAL_REASON: [
        {
            value: '建设中', label: '建设中'
        },
        {
            value: '其他原因', label: '其他原因'
        },
    ],
    CONFIG_CONDITION: [
        {
            value: '工具间', label: '工具间'
        },
        {
            value: '冲洗池', label: '冲洗池'
        },
        {
            value: '保洁制度', label: '保洁制度'
        }
    ],
    CLEANER: [
        {
            value: '有保洁', label: '有保洁'
        },
        {
            value: '无保洁', label: '无保洁'
        },
    ],
    TOILETCONDITIO: [
        {
            "value": '半径200米内有中小学',
            "label": "半径200米内有中小学"
        },
        {
            "value": '半径200米内有集市',
            "label": "半径200米内有集市"
        },
        {
            "value": '半径200米内有文化活动场所',
            "label": "半径200米内有文化活动场所"
        },
        {
            "value": '半径200米内有农村社区综合服务中心',
            "label": "半径200米内有农村社区综合服务中心"
        },
        {
            "value": '半径200米内有集中居住区',
            "label": "半径200米内有集中居住区"
        }
    ],
    TOILET_ENV: [
        {
            "value": "有墙",
            "label": "有墙"
        },
        {
            "value": "有顶",
            "label": "有顶"
        },
        {
            "value": "有门",
            "label": "有门"
        },
        {
            "value": "有通风或有窗",
            "label": "有通风或有窗"
        },
        {
            "value": "有照明或可见光",
            "label": "有照明或可见光"
        },
        {
            "value": "厕屋清洁",
            "label": "厕屋清洁"
        },
        {
            "value": "无恶臭无蝇蛆",
            "label": "无恶臭无蝇蛆"
        },
        {
            "value": "无粪坑暴露",
            "label": "无粪坑暴露"
        },
        {
            "value": "有蹲便器或坐便器",
            "label": "有蹲便器或坐便器"
        }
    ],
    PRIVATE_TOILET_ENV: [
        {
            "value": "有墙",
            "label": "有墙"
        },
        {
            "value": "有顶",
            "label": "有顶"
        },
        {
            "value": "有门",
            "label": "有门"
        },
        {
            "value": "有通风或有窗",
            "label": "有通风或有窗"
        },
        {
            "value": "有照明或可见光",
            "label": "有照明或可见光"
        },
        {
            "value": "厕屋清洁",
            "label": "厕屋清洁"
        },
        {
            "value": "无恶臭无蝇蛆",
            "label": "无恶臭无蝇蛆"
        },
        {
            "value": "无粪坑暴露",
            "label": "无粪坑暴露"
        },
        {
            "value": "有蹲便器或坐便器",
            "label": "有蹲便器或坐便器"
        },
        {
            "value": "有洗漱洗浴",
            "label": "有洗漱洗浴"
        },
        {
            "value": "有洗衣",
            "label": "有洗衣"
        }
    ],
    VALIDS: [
        {
            value: 1, label: '有效'
        },
        {
            value: 2, label: '无效'
        },
    ],
    'SERVICE_STATUS': [
        {
            value: 1, label: '待上线'
        },
        {
            value: 2, label: '服务中'
        },
        {
            value: 3, label: '已过期'
        }
    ],
    'CITY_OPTIONS': [
        {
            value: '520100000000', label: '贵阳市'
        },
        {
            value: '520300000000', label: '遵义市'
        },
        {
            value: '520200000000', label: '六盘水市'
        },
        {
            value: '520400000000', label: '安顺市'
        },
        {
            value: '520500000000', label: '毕节市'
        },
        {
            value: '520600000000', label: '铜仁市'
        },
        {
            value: '522600000000', label: '黔东南州'
        },
        {
            value: '522700000000', label: '黔南州'
        },
        {
            value: '522300000000', label: '黔西南州'
        },
        {
            value: '520100000001', label: '贵安新区'
        },
    ],
    'HOUSE_CITY_OPTIONS': [
        {
            value: '520100000000', label: '贵阳市'
        },
        {
            value: '520300000000', label: '遵义市'
        },
        {
            value: '520200000000', label: '六盘水市'
        },
        {
            value: '520400000000', label: '安顺市'
        },
        {
            value: '520500000000', label: '毕节市'
        },
        {
            value: '520600000000', label: '铜仁市'
        },
        {
            value: '522600000000', label: '黔东南州'
        },
        {
            value: '522700000000', label: '黔南州'
        },
        {
            value: '522300000000', label: '黔西南州'
        },
        {
            value: '520700000000', label: '贵安新区'
        },
    ],

    'IS_WARING': [
        {
            value: 1, label: '是'
        },
        {
            value: 2, label: '否'
        }
    ],
    'PROBLEM_SET': [
        {
            "value": "1", "label": "垃圾乱堆乱倒"
        },
        {
            "value": "2", "label": "垃圾箱满无人清理"
        },
        {
            "value": "3", "label": "垃圾箱缺失"
        },
        {
            "value": "4", "label": "垃圾箱损坏"
        },
        {
            "value": "5", "label": "垃圾露天焚烧"
        },
        {
            "value": "7", "label": "公厕管护"
        },
        {
            "value": "6", "label": "其他"
        }
    ],
    'PROGRESS_PROJECT': [
        {
            value: '正在开展前期准备',
            label: '正在开展前期准备'
        },
        {
            value: '正在施工',
            label: '正在施工'
        },
        {
            value: '已竣工',
            label: '已竣工'
        },
        {
            value: '暂未开展任何工作',
            label: '暂未开展任何工作'
        },

    ],
    'PROGRESS_PROJECT2': [
        {
            value: '改造前',
            label: '改造前'
        },
        {
            value: '改造中',
            label: '改造中'
        },
        {
            value: '改造完成',
            label: '改造完成'
        },
    ],
    VISIBLEARRAY: [
        {
            value: 1,
            label: "启用",
        },
        {
            value: 0,
            label: "冻结",
        },
    ],
    ARRAYMESSAGE: [
        {
            value: 1,
            label: "启用",
        },
        {
            value: 2,
            label: "冻结",
        },
    ],

    MONTH_TYPE: [
        {
            value: 'month',
            label: "自然月",
        },
        {
            value: 'day',
            label: "自然天",
        },
    ],
    ACCOUNT_TYPE_LIST: [
        {
            value: 1,
            label: "省级账号",
            disabled: false,
        },
        {
            value: 2,
            label: "市级账号",
            disabled: false
        },
        {
            value: 3,
            label: "县级账号",
            disabled: false
        },
        {
            value: 4,
            label: "乡镇级账号",
            disabled: false
        },
        {
            value: 5,
            label: "村级账号",
            disabled: false
        }
    ],
    USER_SOURCE: [
        {
            value: 0,
            label: "APP",
        },
        {
            value: 1,
            label: "微信",
        },
        {
            value: 2,
            label: "系统",
        }
    ],
    FACILITY_STATUS: [
        { name: '正常', value: '正常' },
        { name: '堵塞', value: '堵塞' },
        { name: '渗漏', value: '渗漏' },
        { name: '雨污混流', value: '雨污混流' },
    ],
    COUNTY_TYPE: [
        { name: '否', value: 2 },
        { name: '是', value: 1 }
    ],
    STATION_TYPES: [
        { name: '收集点', value: 1 },
        { name: '转运站', value: 2 },
        { name: '处理厂', value: 3 },
    ],
    CAR_TYPES: [
        { name: '清运车', value: 1 },
        { name: '转运车', value: 2 },
    ],
    ECONOMIC_CONDITION_LIST: [
        { name: '建档立卡贫困户', value: 1 },
        { name: '低保户', value: 2 },
        { name: '残疾人', value: 3 },
        { name: '五保户', value: 4 },
        { name: '一般户', value: 5 }
    ],
    RELATIONSHIP_LIST_WITH_HOLDER: [
        { name: '丈夫', value: 1 },
        { name: '妻子', value: 2 },
        { name: '儿子', value: 3 },
        { name: '女儿', value: 4 },
        { name: '孙子', value: 5 },
        { name: '孙女', value: 15 },
        { name: '外孙子', value: 6 },
        { name: '外孙女', value: 7 },
        { name: '父亲', value: 8 },
        { name: '母亲', value: 9 },
        { name: '爷爷', value: 10 },
        { name: '奶奶', value: 11 },
        { name: '外公', value: 12 },
        { name: '外婆', value: 13 },
        { name: '其他', value: 14 }
    ],
    MARKER_TYPE: [
        { name: '检查井', value: 1 },
        { name: '减压井', value: 2 },
        { name: '泵站', value: 3 },
        { name: '校正标注点', value: 4 },
        { name: '漏排点', value: 5 },
        { name: '混搭乱接标注点', value: 6 },
        { name: '其他', value: 7 },
        { name: '接户点', value: 8 },
    ],
    MARKER_MEMBER_TYPE: [
        { name: '已接入', value: 1 },
        { name: '未接入', value: 2 },
        { name: '待核实', value: 3 },
        { name: '不确定', value: 4 },
    ],
    MARKER_ACCESS_TYPE: [
        { name: '居民', value: 1 },
        { name: '小区', value: 2 },
        { name: '学校', value: 3 },
        { name: '医院', value: 4 },
        { name: '企事业单位', value: 5 },
        { name: '其他', value: 6 },
    ],
    BUILD_TIME_LIST: [{
        name: '1949年及以前'
    },
    {
        name: '1950-1959'
    },
    {
        name: '1960-1969'
    },
    {
        name: '1970-1979'
    },
    {
        name: '1980-1989'
    },
    {
        name: '1990-1999'
    },
    {
        name: '2000-2009'
    },
    {
        name: '2010-2019'
    }
    ],
    PLIESNUMBER_LIST: [{
        name: '1',
        value: 1,
    },
    {
        name: '2',
        value: 2,
    },
    {
        name: '3',
        value: 3,
    },
    {
        name: '4',
        value: 4,
    },
    {
        name: '5',
        value: 5,
    },
    {
        name: '6',
        value: 6,
    },
    {
        name: '7',
        value: 7,
    },
    ],
    BUILD_AREA_LIST: [{
        name: '100平米以下',
        value: '100平米以下',
    },
    {
        name: '100-150平米',
        value: '100-150平米',
    },
    {
        name: '150-200平米',
        value: '150-200平米',
    },
    {
        name: '200平米以上',
        value: '200平米以上',
    },
    ],
    STRUCTURE_TYPE_LIST: [{
        name: '木结构',
        value: 1,
    },
    {
        name: '砖混结构',
        value: 2,
    },
    {
        name: '石结构',
        value: 3,
    },
    {
        name: '砖木结构',
        value: 4,
    },
    {
        name: '土坯结构',
        value: 5,
    },
    {
        name: '茅草房',
        value: 6,
    },
    {
        name: '其它',
        value: 7,
    }
    ],
    REMOULD_LEVEL_LIST: [
        // {
        //     name: "一级",
        //     value: 1,
        // },
        // {
        //     name: "二级",
        //     value: 2,
        // },
        // {
        //     name: "三级",
        //     value: 3
        // },
        // {
        //     name: "地质灾害",
        //     value: 4,
        // },
        // {
        //     name: "其他",
        //     value: 5
        // }
        {
            name: "房屋鉴定A级",
            value: 1,
        },
        {
            name: "房屋鉴定B级",
            value: 2,
        },
        {
            name: "房屋鉴定C级",
            value: 3
        },
        {
            name: "房屋鉴定D级",
            value: 4,
        },
        {
            name: "其他",
            value: 5
        }
    ],
    Level_ASSESS_LIST: [{
        name: '全部',
        value: null
    }, {
        name: '一级',
        value: 1
    }, {
        name: '二级',
        value: 2
    }, {
        name: '三级',
        value: 3
    }, {
        name: '其他',
        value: 4
    }, {
        name: '地质灾害',
        value: 5
    }, {
        name: '无',
        value: 6
    }],
    REMOULD_TYPE_LIST: [{
        name: '易地扶贫搬迁户',
        value: 1
    },
    {
        name: '生态、水库移民搬迁',
        value: 2
    },
    {
        name: '养老院（含福利院）',
        value: 3
    },
    {
        name: '与有安全住房亲属共同生活',
        value: 4
    },
    {
        name: '已购商品房',
        value: 5
    },
    {
        name: '公租房（享受租赁补贴）',
        value: 6
    },
    {
        name: '残疾人托养机构',
        value: 7
    },
    {
        name: '租赁住房（含职工宿舍）',
        value: 8
    },
    {
        name: '征收、拆迁（含棚户区改造）',
        value: 9
    },
    {
        name: '闲置安全公房',
        value: 10
    },
    {
        name: '户籍地住房安全',
        value: 11
    },
    {
        name: '无保障方式',
        value: 12
    }
    ],
    YES_NO_LIST: [{
        name: '否',
        value: 0
    },
    {
        name: '是',
        value: 1
    }
    ],
    SAFETY_ASSESS_LIST: [{
        name: 'A',
        value: 1
    },
    {
        name: 'B',
        value: 2
    }
    ],
    YEAR_LIST: [
        { value: "2005" }, { value: "2006" }, { value: "2007" }, { value: "2008" }, { value: "2009" },
        { value: "2010" }, { value: "2011" }, { value: "2012" }, { value: "2013" }, { value: "2014" },
        { value: "2015" }, { value: "2016" }, { value: "2017" }, { value: "2018" }, { value: "2019" },
        { value: "2020" }
    ],
    PROPERTY_REGISTRATION_LIST: [{
        name: '未办理',
        value: 0
    },
    {
        name: '已办理',
        value: 1
    }
    ],
    LINE_DIRECTIONS: [
        {
            name: '无',
            value: '无'
        },
        {
            name: '东',
            value: '东'
        },
        {
            name: '西',
            value: '西'
        },
        {
            name: '南',
            value: '南'
        },
        {
            name: '北',
            value: '北'
        },
    ],
    FACILITYS_STATE: [
        {
            name: '正常',
            value: 1
        },
        {
            name: '缺失',
            value: 2
        },
        {
            name: '破损',
            value: 3
        },
        {
            name: '井盖错乱',
            value: 4
        },
    ],
    CATEGORY: [
        {
            name: '农村住房',
            value: 'rural_housing',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/village_icon.png',
            sub: [
                {
                    name: '自然灾害导致房屋损坏',
                    value: 'natural_disaster'
                },
                {
                    name: '房屋自然损坏',
                    value: 'house_damage'
                },
                {
                    name: '其他',
                    value: 'rural_housing_other'
                }
            ]
        },
        {
            name: '垃圾治理',
            value: 'garbage_management',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/trash_icon.png',
            sub: [
                {
                    name: '垃圾乱堆乱倒',
                    value: 'rubbish'
                },
                {
                    name: '垃圾箱满无人清理',
                    value: 'nobody_clean'
                },
                {
                    name: '垃圾箱缺失、损坏',
                    value: 'damage'
                },
                {
                    name: '其他',
                    value: 'garbage_management_other'
                }
            ]
        },
        {
            name: '厕所治理',
            value: 'toilet_governance',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/wc_icon.png',
            sub: [
                {
                    name: '户厕非卫生厕所',
                    value: 'hygienic_toilets'
                },
                {
                    name: '公厕脏、乱、差',
                    value: 'messy_poor'
                },
                {
                    name: '公厕设施损坏',
                    value: 'damage'
                },
                {
                    name: '公厕不可正常使用',
                    value: 'not_ormal_use'
                },
                {
                    name: '其他',
                    value: 'toilet_governance_other'
                }
            ]
        },
        {
            name: '污水治理',
            value: 'sewage',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/water_icon.png',
            sub: [
                {
                    name: '污水乱泼乱倒',
                    value: 'messy'
                },
                {
                    name: '工业污水偷排',
                    value: 'steal_row'
                },
                {
                    name: '污水管网破损',
                    value: 'damage'
                },
                {
                    name: '井盖损坏、缺失',
                    value: 'missing'
                },
                {
                    name: '其他',
                    value: 'sewage_other'
                }
            ]
        },
        {
            name: '村庄清洁行动',
            value: 'clean',
            iconUrl: 'https://cimg.xiaoheitech.cn/static/icon/clean_icon.png',
            sub: [
                {
                    name: '粪便暴漏',
                    value: 'exposure'
                },
                {
                    name: '杂物乱堆乱放',
                    value: 'misplace'
                },
                {
                    name: '房前屋后脏乱',
                    value: 'messy'
                },
                {
                    name: '其他',
                    value: 'clean_other'
                }
            ]
        }


    ],
    // 监控视频在线状态
    MONITOR_STATUS_ONLINE: [
        {
            value: 1,
            label: '在线'
        },
        {
            value: 2,
            label: '离线'
        },
        {
            value: 3,
            label: '未注册'
        }
    ]

    ,
    // 改造类型
    MODIFICATION_TYPE: [
        {
            value: 1,
            label: '基础类'
        },
        {
            value: 2,
            label: '完善类'
        },
        {
            value: 3,
            label: '提升类'
        },
    ],
    // 基础类关联
    BASIC_CLASS: [
        {
            value: '1',
            label: '供水设施'
        },
        {
            value: '2',
            label: '排水设施'
        }, {
            value: '3',
            label: '供电设施'
        }, {
            value: '4',
            label: '弱电设施'
        }, {
            value: '5',
            label: '道路'
        }, {
            value: '6',
            label: '供气设施'
        }, {
            value: '7',
            label: '供热设施'
        }, {
            value: '8',
            label: '消防设施'
        }, {
            value: '9',
            label: '安防设施'
        }, {
            value: '10',
            label: '消防设施'
        }, {
            value: '11',
            label: '生活垃圾分类设施'
        }, {
            value: '12',
            label: '移动通信设施'
        }, {
            value: '13',
            label: '光纤入户'
        }, {
            value: '14',
            label: '弱电架空线规整（入地）'
        }, {
            value: '15',
            label: '强电架空线规整（绝缘化地）'
        }, {
            value: '16',
            label: '建筑物屋面、外墙、楼梯等维修'
        }, {
            value: '17',
            label: '其他'
        }
    ],
    PEFECT_CLASS: [
        {
            value: '1',
            label: '拆除违法建设'
        },
        {
            value: '2',
            label: '整治小区及周边绿化、照明等'
        }, {
            value: '3',
            label: '适老设施、无障碍设施'
        }, {
            value: '4',
            label: '停车库（场）'
        }, {
            value: '5',
            label: '电动自行车及汽车充电设施'
        }, {
            value: '6',
            label: '智能信包箱、智能快件箱'
        }, {
            value: '7',
            label: '文化休闲场地及设施'
        }, {
            value: '8',
            label: '儿童活动场地'
        }, {
            value: '9',
            label: '物业用房'
        }, {
            value: '10',
            label: '建筑节能改造'
        }, {
            value: '11',
            label: '加装电梯'
        }, {
            value: '12',
            label: '消防车通道划线、标识'
        }, {
            value: '13',
            label: '其他'
        },
    ],
    PROMOTE_CLASS: [
        {
            value: '1',
            label: '社区综合服务设施'
        },
        {
            value: '2',
            label: '卫生服务站等公共卫生设施'
        }, {
            value: '3',
            label: '幼儿园等教育设施'
        }, {
            value: '4',
            label: '周界防护等智能感知设施'
        }, {
            value: '5',
            label: '养老服务设施'
        }, {
            value: '6',
            label: '托育点'
        }, {
            value: '7',
            label: '助餐服务设施'
        }, {
            value: '8',
            label: '家政保洁服务设施'
        }, {
            value: '9',
            label: '便利市场、便利店、超市等'
        }, {
            value: '10',
            label: '邮政快递末端综合服务站'
        }, {
            value: '11',
            label: '其他'
        }
    ],
    buided_station: {
        siteName: '',
        city: '',
        county: '',
        town: '',
        townType: '',
        address: '',
        basin: '',
        constructionStatus: 1,
        commencementTime: '',
        projectPlanningInvestment: '',
        builtUpPopulation: '',
        receivingWater: '',
        completionTime: '',
        operationTime: '',
        operationStatus: '',
        operationDepartment: '',
        builtUpArea: '',
        coveringSurroundingVillage: '',
        constructionScale: '',
        designNetworkLength: '',
        designEmissionStandard: '',
        treatmentProcess: '',
        sludgeDisposalMethod: '',
        integratedEquipmentProcessing: '',
        isCentralizedWaterSupply: '',
        isEstablishChargingMechanism: '',
        isLevySewageTreatmentFee: '',
        treatmentFeeStandard: '',
        facilityInvestmentOperationMode: '',
        longitude: '',
        latitude: '',
        plantAppearancePicture: [],
        tankPicture: [],
        processingPoolsPicture: [],
        builtOtherPicture: [],
        builtRemark: ''
    },
    building_station: {
        siteName: '',
        city: '',
        county: '',
        town: '',
        townType: '',
        address: '',
        basin: '',
        constructionStatus: 2,
        commencementTime: '',
        projectPlanningInvestment: '',
        developmentReformApprovalDocument: '',
        builtUpPopulation: '',
        receivingWater: '',
        completionTime: '',
        operationTime: '',
        operationStatus: '',
        operationDepartment: '',
        builtUpArea: '',
        coveringSurroundingVillage: '',
        constructionScale: '',
        designNetworkLength: '',
        designEmissionStandard: '',
        treatmentProcess: '',
        sludgeDisposalMethod: '',
        integratedEquipmentProcessing: '',
        isCentralizedWaterSupply: '',
        isEstablishChargingMechanism: '',
        isLevySewageTreatmentFee: '',
        treatmentFeeStandard: '',
        facilityInvestmentOperationMode: '',
        longitude: '',
        latitude: '',
        levelingConstructionPicture: [],
        mainConstructionPicture: [],
        equipmentInstallationPicture: [],
        completionAcceptancePicture: [],
        buildingRemark: ''
    },
    no_build_station: {
        siteName: '',
        city: '',
        county: '',
        town: '',
        townType: '',
        address: '',
        basin: '',
        constructionStatus: 3,
        commencementTime: '',
        developmentReformApprovalDocument: '',
        notBuiltRemark: '',
        notBuiltEnterPerson: '',
        notBuiltEnterPersonPhone: '',
        projectApproval: '',
        projectApprovalDocumentNo: '',
        feasibilityStudyApproval: '',
        feasibilityStudyApprovalDocumentNo: '',
        landUseApproval: '',
        landUseApprovalDocumentNo: '',
        eiaApproval: '',
        eiaApprovalDocumentNo: '',
        constructionDepartment: '',
        constructionPermit: '',
        constructionPermitDocumentNo: '',
        biddingRemark: '',
        biddingEnterPerson: '',
        biddingEnterPersonPhone: '',
        longitude: '',
        latitude: '',
        biddingPicture: [],
        builtChangePicture: [],
        notBuiltOtherPicture: []
    },
    building_station_month: {
        build_stage: "",
        finished_investment: "",
        build_net_length: "",
        remark: '',
        recorder: '',
        recorder_phone: '',
        update_time: '',
    },
    builded_station_month: {
        water_supply_towns: "",
        cur_month_inflow: "",
        cur_month_throughput: "",
        cs_cod: '',
        cs_ad: '',
        sludge_production: '',
        remark: '',
        recorder: '',
        recorder_phone: '',
        update_time: '',
    }



};